'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _errors = require('../errors');

var _declarations = require('../utils/declarations');

var _objects = require('../utils/objects');

var _predicate = require('../utils/predicate');

var _renderStyles = require('./renderStyles');

var _renderStyles2 = _interopRequireDefault(_renderStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logDeclarations = function logDeclarations(debugTag) {
  return (0, _ramda.tap)(function (v) {
    if ((0, _ramdaAdjunct.isNotUndefined)(debugTag)) {
      // eslint-disable-next-line no-console
      console.log(debugTag, v);
    }
    return v;
  });
};

var processDeclaration = function processDeclaration(declarationProcessors) {
  return function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        processorName = _ref2[0],
        args = _ref2[1];

    var property = (0, _ramda.prop)(processorName, declarationProcessors);

    (0, _ramda.when)(_ramda.isNil, function () {
      return (0, _errors.throwAPIError)((0, _errors.invalidPropertyError)(processorName));
    })(property);
    return (0, _ramda.pipe)(_ramdaAdjunct.ensureArray, (0, _ramda.apply)(property), (0, _ramdaAdjunct.appendFlipped)(acc))(args);
  };
};

var processDeclarations = function processDeclarations(declarationProcessors) {
  return (0, _ramda.pipe)((0, _objects.reduceObjIndexed)(processDeclaration(declarationProcessors), []), _ramda.unnest);
};

var buildApiFunc = function buildApiFunc(declarationProcessors) {
  return function (value, debugTag) {
    return (0, _ramda.pipe)(processDeclarations(declarationProcessors), _declarations.batchDeclarations, logDeclarations(debugTag), _renderStyles2.default)(value);
  };
};

var attachBreakpointsToDeclarations = function attachBreakpointsToDeclarations(breakpointName, batch) {
  return (0, _objects.reduceObjIndexed)(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        name = _ref4[0],
        value = _ref4[1];

    return (0, _ramda.pipe)((0, _ramda.unless)(_predicate.isValidMqValue, function () {
      return (0, _errors.throwMQError)((0, _errors.unsupportedBreakpointValuesError)(value));
    }), (0, _ramda.objOf)(breakpointName), (0, _ramda.assoc)(name, _ramda.__, acc))(value);
  }, {}, batch);
};

var buildMqFunc = function buildMqFunc(apiFunc) {
  var mqFunc = (0, _ramda.curry)(function (breakpointName, batch) {
    var newMap = attachBreakpointsToDeclarations(breakpointName, batch);
    return apiFunc(newMap);
  });
  apiFunc.mq = mqFunc;
  return apiFunc;
};

var buildApi = (0, _ramda.pipe)(buildApiFunc, buildMqFunc);

exports.default = buildApi;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/build/buildApi.js
// module id = 641
// module chunks = 168707334958949